import React from "react";
import style from "./index.module.scss";
import { Icon, Modal } from "antd";
import { ModalProps } from "antd/lib/modal";

interface LoadingModalProps extends ModalProps {
    title: string;
    content: string;
    onCancel: () => void;
}

export default function LoadingModal({
    onCancel,
    title,
    content,
    ...resProps
}: LoadingModalProps) {
    return (
        <Modal
            maskClosable
            width={416}
            title={null}
            footer={null}
            closable={false}
            className={style.root}
            onCancel={onCancel}
            {...resProps}>
            <Icon type="clock-circle" theme="filled" className={style.icon} />
            <div className={style.title}>{title}</div>
            <div className={style.tip}>{content}</div>
        </Modal>
    );
}
